import { required, unique, shape, items, concatFailure } from '@totalsoft/pure-validations';

export const checklistValidator = shape({
  targetAreaId: required,
  reqDocTypeId: required,
});

export const checklistPropertiesValidator = concatFailure(
  unique(x => x.propertyId || {}, 'Checklist.Validators.PropertyUnique'),
  items(
    shape({
      propertyId: required
    })
  )
);
